import tablecss from "../css/table.module.css";

function Table({ columns = [], data = [] }) {
  console.log("columns",columns);
  console.log("data",data);
  
  return (
    <div className={tablecss.tableContainer}>
      <table className={tablecss.customTable}>
        <thead>
          <tr>  
            {columns.map((col, i) => (
              <th key={i}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, i) => (
              <tr key={i}>
                {columns.map((col, j) => (
                  <td key={j}>{row[col.accessor]}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
